import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { SuppliersBaseRoute } from '../../../../../../../pages/products-page/suppliers/suppliers-routes';
import { useProductDetailsContext } from '../../../../../use-product-details-context';

type SupplierNameCellProps = {
  supplierId: number;
  supplierName: string;
};

export const SupplierNameCell = ({ supplierId, supplierName }: SupplierNameCellProps) => {
  const navigate = useNavigate();
  const { closeModal } = useProductDetailsContext();

  const onClick = useCallback(() => {
    closeModal();
    navigate(`${SuppliersBaseRoute}/${supplierId}`);
  }, [closeModal, navigate, supplierId]);

  return (
    <Button onClick={onClick} theme={THEME_CONSTANTS.link}>
      {supplierName}
    </Button>
  );
};
